exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-content {\n  min-width: 600px;\n  max-height: 70vh;\n  overflow-y: auto; }\n\nh6 {\n  margin-bottom: 10px;\n  color: #666;\n  font-weight: 500; }\n\n.width-100 {\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/CustomersModule/CustomerCreateDialogComponent/customer-create.dialog.component.scss
// module id = ../../../../../src/CustomersModule/CustomerCreateDialogComponent/customer-create.dialog.component.scss
// module chunks = main